import React from 'react';
export function ProofBar() {
  const logos = ['Slack', 'Gmail', 'Google Ads', 'Meta', 'Salesforce', 'HubSpot', 'Stripe', 'QuickBooks', 'Twilio', 'Zapier', 'Calendly', 'Shopify'];
  return <section className="bg-dark-bg py-12 border-y border-white/10 overflow-hidden relative" data-id="element-880" data-mp="7ksm9uj9542h">
      <div className="max-w-7xl mx-auto px-6 mb-6 text-center" data-id="element-881" data-mp="cikp3jlfqalg">
        <p className="font-poppins font-semibold text-sm tracking-wider uppercase text-steel" data-id="element-882" data-mp="3upij0tpsmyv8">
          MISTR connects to your entire world.
        </p>
      </div>

      {/* Gradient Fade Edges */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-dark-bg to-transparent z-10 pointer-events-none" data-id="element-883" data-mp="3ksdwutvy73ef" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-dark-bg to-transparent z-10 pointer-events-none" data-id="element-884" data-mp="3pr780fnriibf" />

      {/* Infinite Scroll Container */}
      <div className="relative flex overflow-x-hidden group" data-id="element-885" data-mp="1ny9c2ayov9m9">
        <div className="animate-marquee flex whitespace-nowrap items-center" data-id="element-886" data-mp="2seylhnp23twr">
          {[...logos, ...logos].map((logo, index) => <div key={index} className="mx-8 text-2xl font-poppins font-bold text-white hover:text-purple transition-colors duration-300 cursor-default" data-id="element-887" data-mp="2neu4zxo5ez6j" data-mpi={index}>
              {logo}
            </div>)}
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .group:hover .animate-marquee {
          animation-play-state: paused;
        }
      `
    }} data-id="element-888" data-mp="29fufknstag9b" />
    </section>;
}